import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {CurrencyFormatter, optionsTemplate, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

const sortable = true;
const filterable = true;

class InventoryForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="store"
                            storeType="remote"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Raktár"
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="type"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Típus"
                            formatter={(value) => value + "" === "1" ? "Teljes" : "Részleges"}
                            disabled={true}
                        />
                    </div>
                    <div className="col-md-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="date"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Dátum"
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <SelectorGrid
                            {...this.props.getFieldProps("items")}
                            className={"p-small-table"}
                            exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                            aggregations={{
                                fields: {
                                    "stock": {
                                        field: "stock", type: "SUM"
                                    },
                                    "qty": {
                                        field: "qty", type: "SUM"
                                    },
                                }
                            }}
                            view={["product_id"]}
                            columns={{
                                "displayname": {
                                    ...ProductColumn("product_id"),
                                    width: 8,
                                },
                                "barcode": {
                                    header: 'Vonalkód',
                                    width: 1,
                                    sortable,
                                    filterable
                                },
                                "listprice": {
                                    header: 'Listaár',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    renderer: CurrencyFormatter,
                                    className: "currency"
                                },
                                "stock": {
                                    header: 'Készlet',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    className: "unit",
                                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                },
                                "qty": {
                                    header: 'Leltár',
                                    width: 1,
                                    sortable,
                                    filterable,
                                    className: "unit",
                                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                },
                            }}
                            listfield="items"
                            data={this.props.values}
                            orderBy={{field: "displayname", direction: "ASC"}}
                            componentConfig={this.props.componentConfig}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(InventoryForm);
